import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class WalkOfShameGameAssets {
    public static BITMAP_FONT_WIN_COUNT_UP = "countup";
    public static BITMAP_WAYS_COUNT_UP = "waysWon";
    public static BITMAP_POSSIBLE_WAYS = "waysCountup_main_FS";
    public static BITMAP_POSSIBLE_WAYS_SFS = "waysCountup_SFS";

    public static MAIN_GAME_BACKGROUND: string = "mainBackground";
    public static FREE_SPIN_BACKGROUND: string = "freespinBackground";

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                assets: [
                    new BitmapFontAsset(WalkOfShameGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/countup.fnt"),
                    new BitmapFontAsset(WalkOfShameGameAssets.BITMAP_WAYS_COUNT_UP, "fonts/bitmapfonts/waysWon.fnt"),
                    new BitmapFontAsset(WalkOfShameGameAssets.BITMAP_POSSIBLE_WAYS, "fonts/bitmapfonts/waysCountup_main_FS.fnt"),
                    new BitmapFontAsset(WalkOfShameGameAssets.BITMAP_POSSIBLE_WAYS_SFS, "fonts/bitmapfonts/waysCountup_SFS.fnt")
                ]
            },
            {
                name: "backgrounds",
                assets: [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json")
                ]
            },
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json"),
                    new TextureAsset("main6", "sheets/main/main6.json")
                ]
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json")
                ]
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                    new TextureAsset("symbols1", "sheets/symbols/symbols1.json")
                ]
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("M1_full", "spine/wos_spine/W1.json"),
                    new SpineAsset("M2_full", "spine/wos_spine/W2.json"),
                    new SpineAsset("M3_full", "spine/wos_spine/W3.json"),
                    new SpineAsset("M4_full", "spine/wos_spine/W4.json"),
                    new SpineAsset("S", "spine/wos_spine/S.json"),
                    new SpineAsset("S2", "spine/wos_spine/S2.json"),
                    new SpineAsset("M1", "spine/wos_spine/M1.json"),
                    new SpineAsset("M2", "spine/wos_spine/M2.json"),
                    new SpineAsset("M3", "spine/wos_spine/M3.json"),
                    new SpineAsset("M4", "spine/wos_spine/M4.json"),
                    new SpineAsset("L1", "spine/wos_spine/L1.json"),
                    new SpineAsset("L2", "spine/wos_spine/L2.json"),
                    new SpineAsset("L3", "spine/wos_spine/L3.json"),
                    new SpineAsset("L4", "spine/wos_spine/L4.json"),
                    new SpineAsset("L5", "spine/wos_spine/L5.json"),
                    new SpineAsset("anticipation", "spine/nearWin.json"),
                    new SpineAsset("scatter2", "spine/wos_spine/S2.json"),
                    new SpineAsset("multiplierEffect", "spine/multiplier.json"),
                    new SpineAsset("multiplierLanding", "spine/multiplierLanding.json"),
                    new SpineAsset("champagne", "spine/bigwin/Champagne.json"),
                    new SpineAsset("intro", "spine/Intro.json"),
                    new SpineAsset("outro", "spine/Outro.json"),
                    new SpineAsset("just-a-sip", "spine/bigwin/just-a-sip.json"),
                    new SpineAsset("tipsy", "spine/bigwin/tipsy.json"),
                    new SpineAsset("filthy", "spine/bigwin/filthy.json"),
                    new SpineAsset("wasted", "spine/bigwin/wasted.json"),
                    new SpineAsset("wrecked", "spine/bigwin/wrecked.json"),
                    new SpineAsset("wreckingBall", "spine/bigwin/WreckingBall.json"),
                    new SpineAsset("capWin", "spine/capWin/capWin.json"),
                    new SpineAsset("happilyEverAfter", "spine/capWin/HappilyEverAfter.json"),
                    new SpineAsset("sfsBg", "spine/SFS/SFS_BG.json"),
                    new SpineAsset("logo", "spine/logo/Logo.json")
                ]
            }
        ]
    };
}